import Cookies from 'js-cookie';

const TRACKING_PARAMS = [
  'gclid',
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

const COOKIE_PREFIX = 'uv_';
const COOKIE_DURATION = 90;

/**
 * Clear all tracking cookies
 */
function clearTrackingCookies() {
  const allCookies = Cookies.get();

  $.each(allCookies, function (cookieName) {
    if (cookieName.startsWith(COOKIE_PREFIX)) {
      Cookies.remove(cookieName);
    }
  });
}

/**
 * Check if user has given consent for marketing cookies
 */
function hasTrackingConsent() {
  if (typeof window.cmplz_has_consent === 'function') {
    return window.cmplz_has_consent('marketing');
  }

  return false;
}

/**
 * Get URL parameters
 */
function getUrlParameters() {
  const parameters = {};
  const searchParameters = new URLSearchParams(window.location.search);

  $.each(TRACKING_PARAMS, function (_, parameter) {
    const value = searchParameters.get(parameter);

    if (value) {
      parameters[parameter] = value;
    }
  });

  return parameters;
}

/**
 * Capture and store tracking parameters
 */
function captureTrackingParameters() {
  if (!hasTrackingConsent()) {
    clearTrackingCookies();

    return;
  }

  const urlParameters = getUrlParameters();

  $.each(urlParameters, function (parameter, value) {
    const cookieName = COOKIE_PREFIX + parameter;
    Cookies.set(cookieName, value, {expires: COOKIE_DURATION, path: '/', sameSite: 'Lax'});
  });

  const fbpCookie = Cookies.get('_fbp');

  if (fbpCookie) {
    Cookies.set(COOKIE_PREFIX + 'fbp', fbpCookie, {expires: COOKIE_DURATION, path: '/', sameSite: 'Lax'});
  }

  if (!Cookies.get(COOKIE_PREFIX + 'first_visit')) {
    const now = new Date();
    const timestamp = now.toISOString().slice(0, 19).replace('T', ' ');
    Cookies.set(COOKIE_PREFIX + 'first_visit', timestamp, {expires: COOKIE_DURATION, path: '/', sameSite: 'Lax'});
  }
}

/**
 * Listen to Complianz consent changes
 */
function initConsentListener() {
  $(document).on('cmplz_status_change', function () {
    if (hasTrackingConsent()) {
      captureTrackingParameters();
    } else {
      clearTrackingCookies();
    }
  });
}

/**
 * Initialize tracking on page load
 */
function initTracking() {
  captureTrackingParameters();
  initConsentListener();
}

$(document).ready(function () {
  initTracking();
});
